import { render, staticRenderFns } from "./ProductionOrderItemModal.vue?vue&type=template&id=0593570a"
import script from "./ProductionOrderItemModal.vue?vue&type=script&lang=js"
export * from "./ProductionOrderItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports